import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {InjectedFormProps, change, getFormValues, reduxForm} from 'redux-form';
import {ProductsPriceFilterForm, defaultFilterPrice, validationProductPriceFormItems} from '../model';
import {Forms} from '../../../../shared/models/forms';
// import {productPricesSelector} from '../../../../redux/selectors/products';
import {ProductPriceResponsePayload} from '../../../../shared/models/api/productPriceResponsePayload';
import View from './view';
import {validationPipe} from '../../../../shared/pipes';
import {addNotification} from '../../../../redux/actions/snackbar';
import {SnackbarNotificationType} from '../../../../shared/components/snackbar/model';

export interface ProductsPriceFilterProps {
  visuallyImpaired?: boolean;
  onFilterApply?: (formData: ProductsPriceFilterForm) => void;
}

const getFormErrors = (formData: ProductsPriceFilterForm) => {
  return validationPipe(formData, validationProductPriceFormItems);
};

const _ProductsPricerFilter: React.FC<
  ProductsPriceFilterProps & InjectedFormProps<ProductsPriceFilterForm, ProductsPriceFilterProps>
> = ({onFilterApply = () => undefined, handleSubmit, ...props}) => {
  // const productPrices = useSelector(productPricesSelector());
  const productPrices = {};
  const onSubmit = React.useCallback((e: any) => {
    e?.preventDefault();
    handleSubmit(onFilterApply)();
  }, []);

  const dispatch = useDispatch();
  const productPriceFormValues = useSelector(getFormValues(Forms.productsPriceFilterForm)) as ProductsPriceFilterForm;

  const productPriceFormErrors = getFormErrors(productPriceFormValues);
  if (productPriceFormErrors) {
    dispatch(
      addNotification({
        duration: 2000,
        message: productPriceFormErrors.productPrice.error,
        type: SnackbarNotificationType.Error,
      }),
    );
    if (productPriceFormValues && productPriceFormValues.productPrice) {
      productPriceFormValues.productPrice.map((price, priceIndex) => {
        if ((price < defaultFilterPrice.minPrice || price > defaultFilterPrice.maxPrice) && priceIndex === 0)
          dispatch(change(Forms.productsPriceFilterForm, 'productPrice[0]', defaultFilterPrice.minPrice));
        if ((price < defaultFilterPrice.minPrice || price > defaultFilterPrice.maxPrice) && priceIndex === 1)
          dispatch(change(Forms.productsPriceFilterForm, 'productPrice[1]', defaultFilterPrice.maxPrice));
      });
    }
  }
  return <View onSubmit={onSubmit} productPrices={productPrices} {...props} />;
};

export const ProductsPriceFilter = reduxForm<ProductsPriceFilterForm, ProductsPriceFilterProps>({
  form: Forms.productsPriceFilterForm,
  destroyOnUnmount: false,
})(_ProductsPricerFilter);
